import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation RunMultiPromptRunnerAsync(
    $chainId: ID!
    $cloneChain: Boolean
    $csvChainId: ID
    $blocksUpdatedSettings: JSON!
    $removedBlocks: [ID!]
  ) {
    runMultiPromptRunnerAsync(
      chainId: $chainId
      cloneChain: $cloneChain
      csvChainId: $csvChainId
      blocksUpdatedSettings: $blocksUpdatedSettings
      removedBlocks: $removedBlocks
    ) {
      chainId
      csvChainId
    }
  }
`;

export const runMultiPromptRunnerAsync = async ({
  chainId,
  cloneChain,
  csvChainId,
  blocksUpdatedSettings,
  removedBlocks,
}) => {
  const variables = {
    chainId,
    cloneChain,
    csvChainId,
    blocksUpdatedSettings,
    removedBlocks,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
